import { getMockPolicies } from "../builders/getMockPolicies";
import { legacyCanadaSecondGearMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

export const wayneGretzky: MockPersona = {
  key: "wayneGretzky",
  name: "Wayne Gretzky",
  description: "🇨🇦 | Single Enthusiast+ policy | HDC 1.0 Single-tier | No alerts/autopay successful",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [],
        canada: getMockPolicies("apexCan001"),
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "wayne@gretzky.com",
            firstName: "Wayne",
            middleName: "",
            lastName: "Gretzky",
            mailingAddress: {
              line1: "190 King George Rd",
              line2: "",
              city: "Brantford",
              state: "ON",
              postalCode: "N3R 5L3",
              country: "CANADA",
            },
            preferredPhone: "5190452476",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000029",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: legacyCanadaSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
